import type { IDeviceTokenRepository } from '../../domain/repositories/IDeviceTokenRepository.js';
import type { DeviceTokenRemoteDataSource, DeviceType } from '../datasources/DeviceTokenRemoteDataSource.js';

export class DeviceTokenRepository implements IDeviceTokenRepository {
  constructor(private readonly remoteDataSource: DeviceTokenRemoteDataSource) {}

  register(input: { userId: string; fcmToken: string; deviceType: DeviceType }): Promise<void> {
    return this.remoteDataSource.upsertToken(input);
  }

  remove(fcmToken: string): Promise<void> {
    return this.remoteDataSource.deleteToken(fcmToken);
  }
}
